import React, { useState, useEffect } from "react";
import Pdf from "../../editable-stuff/resume.pdf";

const AboutMe = () => {
  const [resumeURL] = useState(Pdf);

  return (
    <div id="aboutme" className="jumbotron jumbotron-fluid bg-white m-0">
      <div className="container-fluid p-5">
        <div className="row p-3">
            <div className="col-lg-4 d-none d-lg-block align-self-center">
              <img
                className="border border-secondary img-fluid rounded-circle"
                src={require("./ProjectModals/modalimgs/profilepic.jpg")}
                alt="profilepicture"
              />
            </div>
          <div className="col-lg-7">
            <h1 className="display-2 mb-5 col text-center">
              About
            </h1>
            <p className="text-center aboutdescription">
              I love to create and there are three things that inspire me to do so: <br></br>
              my passion for science and engineering, my fascination with technology, and my desire to make a positive contribution to the world. My education has provided me with a variety of experiences and opportunities that molded me into the highly motivated and focused individual I am today. I have always been interested in science and pursued a bachelor’s degree in biochemistry and mathematics. I have conducted research in CRISPR technology, organic compound synthesis, and stem cell research. <br></br>
              I am extremely passionate about learning new and innovative applications of technology. I have completed courses and projects in artificial intelligence, data science, programming and automation, as well as software engineering and development. I am currently pursuing an MS in Chemical Engineering with a focus in Data and Computational Science at Columbia University. I am extremely interested in the unification of technology and engineering, and I aspire to push the boundaries of science and technology in the hopes of bettering the world in new and innovative ways.
            </p>
            {resumeURL && (
              <p className="lead text-center">
                
                {/* Resume Link */}
                <a
                  className="btn btn-outline-dark btn-lg"
                  href={Pdf}
                  target="_blank"
                  rel="noreferrer noopener"
                  role="button"
                  aria-label="Resume/CV"
                >
                  Resume
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
